
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ApplicationForm from './components/ApplicationForm';
import ProcessTimeline from './components/ProcessTimeline';
import StatusQuery from './components/StatusQuery';
import CustomerService from './components/CustomerService';

const ApplyPage = () => {
  const [showCustomerService, setShowCustomerService] = useState(false);

  return (
    <div className="min-h-screen bg-[#F9F9F9]">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative pt-24 md:pt-32 pb-12 md:pb-20 bg-gradient-to-br from-[#2A7A62] to-[#3A9A82]">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="text-center text-white">
            <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6">申请帮助</h1>
            <p className="text-base md:text-xl text-white/90 max-w-2xl mx-auto">
              我们致力于为一线工作者提供支持，如果您符合条件，欢迎提交申请
            </p>
          </div>
        </div>
      </div>

      {/* Warning Box - Application Requirements */}
      <div className="max-w-[1200px] mx-auto px-6 -mt-6 md:-mt-10 relative z-10">
        <div className="bg-gradient-to-r from-[#FFF9E6] to-[#FFF4D6] border-l-4 border-[#F4B942] rounded-xl p-4 md:p-8 shadow-lg">
          <div className="flex items-start gap-3 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-[#F4B942] rounded-full flex-shrink-0">
              <i className="ri-information-line text-white text-lg md:text-2xl"></i>
            </div>
            <div>
              <h3 className="text-lg md:text-2xl font-bold text-[#1E1E1E] mb-3 md:mb-4">申请条件说明</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-3 text-[#1E1E1E]">
                <p className="flex items-start gap-2 text-xs md:text-base">
                  <i className="ri-checkbox-circle-fill text-[#2A7A62] text-base md:text-xl mt-0.5 flex-shrink-0"></i>
                  <span><strong>服务对象：</strong>环卫工人、快递员、外卖骑手、建筑工人、交通协管员等</span>
                </p>
                <p className="flex items-start gap-2 text-xs md:text-base">
                  <i className="ri-checkbox-circle-fill text-[#2A7A62] text-base md:text-xl mt-0.5 flex-shrink-0"></i>
                  <span><strong>基本要求：</strong>需提供工作证明或单位证明</span>
                </p>
                <p className="flex items-start gap-2 text-xs md:text-base">
                  <i className="ri-checkbox-circle-fill text-[#2A7A62] text-base md:text-xl mt-0.5 flex-shrink-0"></i>
                  <span><strong>申请方式：</strong>个人或单位集体申请均可</span>
                </p>
                <p className="flex items-start gap-2 text-xs md:text-base">
                  <i className="ri-checkbox-circle-fill text-[#2A7A62] text-base md:text-xl mt-0.5 flex-shrink-0"></i>
                  <span><strong>审核周期：</strong>3-5个工作日内完成审核</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Process Timeline */}
      <div className="max-w-[1200px] mx-auto px-6 py-8 md:py-16">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-[#1E1E1E] mb-2 md:mb-4">申请流程</h2>
          <p className="text-sm md:text-lg text-[#6C6C6C]">简单四步，轻松完成申请</p>
        </div>
        <ProcessTimeline />
      </div>

      {/* Application Form */}
      <div className="max-w-[1200px] mx-auto px-6 pb-8 md:pb-16">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 lg:p-12">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-bold text-[#1E1E1E] mb-2 md:mb-4">在线申请</h2>
            <p className="text-sm md:text-lg text-[#6C6C6C]">请如实填写以下信息，我们将尽快处理您的申请</p>
          </div>
          <ApplicationForm />
        </div>
      </div>

      {/* Status Query */}
      <div className="max-w-[1200px] mx-auto px-6 pb-8 md:pb-16">
        <StatusQuery />
      </div>

      {/* Customer Service Float Button */}
      <button
        onClick={() => setShowCustomerService(true)}
        className="fixed bottom-6 right-6 md:bottom-8 md:right-8 w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-[#2A7A62] to-[#3A9A82] rounded-full shadow-2xl flex items-center justify-center text-white hover:scale-110 transition-transform duration-300 z-40 cursor-pointer group"
      >
        <i className="ri-customer-service-2-fill text-2xl md:text-3xl group-hover:animate-pulse"></i>
      </button>

      {/* Customer Service Dialog */}
      {showCustomerService && (
        <CustomerService onClose={() => setShowCustomerService(false)} />
      )}

      <Footer />
    </div>
  );
};

export default ApplyPage;
